import { useUpdateMatchingStateMutation } from '../../api';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useUpdateMatchingState = (options: any) => {
  const { headerWithAuth } = useGetAccessToken();
  const { mutate } = useUpdateMatchingStateMutation(headerWithAuth, options);

  return mutate;
};

export {
  useUpdateMatchingState,
};
